
export const styles = {
  cardActionStyleSmall: {
    zIndex: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  containerSmall: {
    padding: '3em 1em 6em 1em'
  },
  containerMedium: {
    padding: '0em 1em 1em 1em'
  },
  containerVariant:{color:'rgba(0, 0, 0, 0.3)', paddingTop: 10, paddingBottom:10},
  containerProperties:{color:'rgba(0, 0, 0, 0.3)', paddingTop: 10, paddingBottom:10},
  selectOptions:{width: '120px'},
  rowOptions:{width: '120px', paddingLeft:0, paddingRight:0},
  rowFooter:{textAlign: 'right', width: 30, padding: 0 },
  removeButton:{minWidth: 30},
  containerToggle:{marginBottom: 16},
  containerSmallFields: {width: 50},
  containerActive: {width: 80}


}


export const iconStyles = {
  marginLeft: 16,
  width:24,
  height:24
};


export const dataColors = [
  { id: "black", name: "Black" },
  { id: "brown", name: "Brown" },
  { id: "blue", name: "Blue" },
  { id: "orange", name: "Orange" },
  { id: "rose_gold", name: "Rose Gold" },
  { id: "gold", name: "Gold" },
  { id: "white", name: "White" },
  { id: "green", name: "Green" },
  { id: "gray", name: "Gray" },
  { id: "silver", name: "Silver" },
  { id: "red", name: "Red" },
  { id: "purple", name: "Purple" },
  { id: "dark_blue", name: "Dark Blue" },
  { id: "yellow", name: "Yellow" }
];


// WEBPACK FOOTER //
// ./src/products/styles.js